
    import {Component, Vue} from "vue-property-decorator";
    import {dictApi} from "@/api/organization";
    import TableShowRangeBody from "@/components/table-show-range-body.vue";

    @Component({
        name: "mechanismList",
        components: {TableShowRangeBody}
    })
    export default class Home extends Vue {
        private exportExcel: any;
        tableData = [];
        onExportExcel() {
            const loading = this.$loading({
                text: '正在导出Excel',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.exportExcel(() => {
                loading.close();
            }, '器具字典.xlsx');
        }
        created(){
            this.loadDataList();
        }

        packageInstrument(d: any, level: number, contentList: any){
            const c = {
                text: d.name,
                level: level,
                rules: d.rules,
                strong: d.strong === 0 ? '非强检' : '强检',
                type: d.type === 1 ? '主' : '别',
                isMustPassParam: d.isMustPassParam === 1 ? "是" : "无",
                upperLimit: d.upperLimit,
                lowerLimit: d.lowerLimit,
            };
            contentList.push(c);
            if(d.children.length > 0 ){
                d.children.forEach((dd: any) => {
                    this.packageInstrument(dd ,level + 1,contentList);
                });
            }
        }

        loadDataList(){
            dictApi.listDictInstrument().then((res: any) => {
                const dataList = res.data.data;
                const contentList = [] as any;
                dataList.forEach((d: any) => {
                    this.packageInstrument(d, 1, contentList);
                });
                this.tableData = contentList;
            });
        }

    }
